import { ActionIcon, Tooltip } from "@mantine/core";
import { forwardRef } from "react";

import { useAnalytics } from "@/analytics";

import type { IconButtonProps } from "./types";

import styles from "./IconButton.module.css";

const IconButtonWrapper = forwardRef<HTMLButtonElement, IconButtonProps>(function IconButtonWrapper(
    // oxlint-disable-next-line no-unused-vars
    { active, tooltip, ...rest }: IconButtonProps,
    ref,
) {
    return <ActionIcon {...rest} ref={ref} />;
});

export function IconButton(props: IconButtonProps) {
    const { dispatcher } = useAnalytics();
    const { actionId, extraContext, eventData } = props.analytics;
    const enhancedDispatcher = extraContext ? dispatcher.withExtra(extraContext) : dispatcher;

    function onClick(event: React.MouseEvent<HTMLButtonElement>) {
        void enhancedDispatcher.dispatchAction("ButtonClick", actionId, { ...eventData });
        props.onClick?.(event);
    }

    const handleWrapperEnter = () => {
        void enhancedDispatcher.dispatchAction("KeypressEnter", actionId, eventData);
    };

    return (
        <Tooltip label={props.tooltip} position="bottom" zIndex={999}>
            <IconButtonWrapper
                className={props.active ? styles.iconButtonActive : styles.iconButtonRoot}
                {...props}
                onClick={onClick}
                onKeyUp={(e) => e.key === "Enter" && handleWrapperEnter}
            >
                {props.children}
            </IconButtonWrapper>
        </Tooltip>
    );
}
